import React, { Component } from 'react';
import { Form, Input, Button, message, Checkbox, DatePicker, Row, Col, InputNumber, Select, Spin } from 'antd';
import Helpers from '../../utils/helper';
import moment from 'moment';
import CapacitacionService from '../../services/api/capacitaciones';

const FormItem = Form.Item;
const Option = Select.Option;
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};

const formItemLayoutMedio = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 12 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 12 },
  },
};

const formItemLayoutWithOutLabel = {
  wrapperCol: {
    xs: { span: 24, offset: 0 },
    sm: { span: 24, offset: 8 },
  },
};

const dateFormat = 'DD/MM/YYYY';

class CapacitacionFormulario extends Component {
  state = {
    id: this.props.capacitacion && this.props.capacitacion.id ? this.props.capacitacion.id : '',
    nombre: this.props.capacitacion && this.props.capacitacion.nombre ? this.props.capacitacion.nombre : '',
    producto_sku: this.props.capacitacion && this.props.capacitacion.producto_sku ? this.props.capacitacion.producto_sku : '',
    producto_formato: this.props.capacitacion && this.props.capacitacion.producto_formato ? this.props.capacitacion.producto_formato : '',
    fecha_inicio: this.props.capacitacion && this.props.capacitacion.fecha_inicio ? this.props.capacitacion.fecha_inicio : '',
    fecha_fin: this.props.capacitacion && this.props.capacitacion.fecha_fin ? this.props.capacitacion.fecha_fin : '',
    es_uso_bonificacion: this.props.capacitacion && this.props.capacitacion.es_uso_bonificacion ? this.props.capacitacion.es_uso_bonificacion : false,
    es_gratuito: this.props.capacitacion && this.props.capacitacion.es_gratuito ? this.props.capacitacion.es_gratuito : false,
    presencial_cantidad: this.props.capacitacion && this.props.capacitacion.presencial_cantidad ? this.props.capacitacion.presencial_cantidad : 0,
    presencial_precio_habil_vitalicio: this.props.capacitacion && this.props.capacitacion.presencial_precio_habil_vitalicio ? this.props.capacitacion.presencial_precio_habil_vitalicio : 0,
    presencial_precio_no_habil: this.props.capacitacion && this.props.capacitacion.presencial_precio_no_habil ? this.props.capacitacion.presencial_precio_no_habil : 0,
    presencial_precio_publico: this.props.capacitacion && this.props.capacitacion.presencial_precio_publico ? this.props.capacitacion.presencial_precio_publico : 0,
    presencial_precio_bachiller_estudiante: this.props.capacitacion && this.props.capacitacion.presencial_precio_bachiller_estudiante ? this.props.capacitacion.presencial_precio_bachiller_estudiante : 0,
    presencial_precio_cooporativo: this.props.capacitacion && this.props.capacitacion.presencial_precio_cooporativo ? this.props.capacitacion.presencial_precio_cooporativo : 0,
    virtual_cantidad: this.props.capacitacion && this.props.capacitacion.virtual_cantidad ? this.props.capacitacion.virtual_cantidad : 0,
    virtual_precio_habil_vitalicio: this.props.capacitacion && this.props.capacitacion.virtual_precio_habil_vitalicio ? this.props.capacitacion.virtual_precio_habil_vitalicio : 0,
    virtual_precio_no_habil: this.props.capacitacion && this.props.capacitacion.virtual_precio_no_habil ? this.props.capacitacion.virtual_precio_no_habil : 0,
    virtual_precio_publico: this.props.capacitacion && this.props.capacitacion.virtual_precio_publico ? this.props.capacitacion.virtual_precio_publico : 0,
    virtual_precio_bachiller_estudiante: this.props.capacitacion && this.props.capacitacion.virtual_precio_bachiller_estudiante ? this.props.capacitacion.virtual_precio_bachiller_estudiante : 0,
    virtual_precio_cooporativo: this.props.capacitacion && this.props.capacitacion.virtual_precio_cooporativo ? this.props.capacitacion.virtual_precio_cooporativo : 0,
    hibrido_cantidad: this.props.capacitacion && this.props.capacitacion.hibrido_cantidad ? this.props.capacitacion.hibrido_cantidad : 0,
    hibrido_precio_habil_vitalicio: this.props.capacitacion && this.props.capacitacion.hibrido_precio_habil_vitalicio ? this.props.capacitacion.hibrido_precio_habil_vitalicio : 0,
    hibrido_precio_no_habil: this.props.capacitacion && this.props.capacitacion.hibrido_precio_no_habil ? this.props.capacitacion.hibrido_precio_no_habil : 0,
    hibrido_precio_publico: this.props.capacitacion && this.props.capacitacion.hibrido_precio_publico ? this.props.capacitacion.hibrido_precio_publico : 0,
    hibrido_precio_bachiller_estudiante: this.props.capacitacion && this.props.capacitacion.hibrido_precio_bachiller_estudiante ? this.props.capacitacion.hibrido_precio_bachiller_estudiante : 0,
    hibrido_precio_cooporativo: this.props.capacitacion && this.props.capacitacion.hibrido_precio_cooporativo ? this.props.capacitacion.hibrido_precio_cooporativo : 0,
    descuento_valor: this.props.capacitacion && this.props.capacitacion.descuento_valor ? this.props.capacitacion.descuento_valor : '',
    descuento_tipo: this.props.capacitacion && this.props.capacitacion.descuento_tipo ? this.props.capacitacion.descuento_tipo : '',
    productos: [],
    validators: {
      nombre: {
        rules: [
          {
            test: (value) => value.trim().length > 0,
            message: 'Campo obligatorio.',
          },
          {
            test: /^[a-zA-ZñÑáéíóúÁÉÍÓÚ0-9 ]*$/,
            message: 'El campo acepta solo alfanuméricos.',
          },
          {
            test: (value) => value.trim().length <= 255,
            message: 'El campo acepta 255 caracteres.',
          },
        ],
        errors: [],
        valid: true,
        state: '',
      },
      producto_sku: {
        rules: [
          {
            test: (value) => value.trim().length > 0,
            message: 'Campo obligatorio.',
          }
        ],
        errors: [],
        valid: true,
        state: '',
      },
      fecha_inicio: {
        rules: [
          {
            test: (value) => value.trim().length > 0,
            message: 'Campo obligatorio.',
          },
        ],
        errors: [],
        valid: true,
        state: '',
      },
      fecha_fin: {
        rules: [
          {
            test: (value) => value.trim().length > 0,
            message: 'Campo obligatorio.',
          },
        ],
        errors: [],
        valid: true,
        state: '',
      },
      presencial_cantidad: {
        rules: [
          {
            test: (value) => {
              let valid = true;
              if (!this.state.es_gratuito) {
                if (!(value.toString().trim().length >= 0)) {valid = false;}
              }
              return valid;
            },
            message: 'Campo obligatorio.',
          },
        ],
        errors: [],
        valid: true,
        state: '',
      },
      presencial_precio_habil_vitalicio: {
        rules: [
          {
            test: (value) => {
              let valid = true;
              if (!this.state.es_gratuito) {
                if (!(value.toString().trim().length >= 0)) {valid = false;}
              }
              return valid;
            },
            message: 'Campo obligatorio.',
          },
        ],
        errors: [],
        valid: true,
        state: '',
      },
      presencial_precio_publico: {
        rules: [
          {
            test: (value) => {
              let valid = true;
              if (!this.state.es_gratuito) {
                if (!(value.toString().trim().length >= 0)) {valid = false;}
              }
              return valid;
            },
            message: 'Campo obligatorio.',
          },
        ],
        errors: [],
        valid: true,
        state: '',
      },
      presencial_precio_bachiller_estudiante: {
        rules: [
          {
            test: (value) => {
              let valid = true;
              if (!this.state.es_gratuito) {
                if (!(value.toString().trim().length >= 0)) {valid = false;}
              }
              return valid;
            },
            message: 'Campo obligatorio.',
          },
        ],
        errors: [],
        valid: true,
        state: '',
      },
      presencial_precio_cooporativo: {
        rules: [
          {
            test: (value) => {
              let valid = true;
              if (!this.state.es_gratuito) {
                if (!(value.toString().trim().length >= 0)) {valid = false;}
              }
              return valid;
            },
            message: 'Campo obligatorio.',
          },
        ],
        errors: [],
        valid: true,
        state: '',
      },
      virtual_cantidad: {
        rules: [
          {
            test: (value) => {
              let valid = true;
              if (!this.state.es_gratuito) {
                if (!(value.toString().trim().length >= 0)) {valid = false;}
              }
              return valid;
            },
            message: 'Campo obligatorio.',
          },
        ],
        errors: [],
        valid: true,
        state: '',
      },
      virtual_precio_habil_vitalicio: {
        rules: [
          {
            test: (value) => {
              let valid = true;
              if (!this.state.es_gratuito) {
                if (!(value.toString().trim().length >= 0)) {valid = false;}
              }
              return valid;
            },
            message: 'Campo obligatorio.',
          },
        ],
        errors: [],
        valid: true,
        state: '',
      },
      virtual_precio_no_habil: {
        rules: [
          {
            test: (value) => {
              let valid = true;
              if (!this.state.es_gratuito) {
                if (!(value.toString().trim().length >= 0)) {valid = false;}
              }
              return valid;
            },
            message: 'Campo obligatorio.',
          },
        ],
        errors: [],
        valid: true,
        state: '',
      },
      virtual_precio_publico: {
        rules: [
          {
            test: (value) => {
              let valid = true;
              if (!this.state.es_gratuito) {
                if (!(value.toString().trim().length >= 0)) {valid = false;}
              }
              return valid;
            },
            message: 'Campo obligatorio.',
          },
        ],
        errors: [],
        valid: true,
        state: '',
      },
      virtual_precio_bachiller_estudiante: {
        rules: [
          {
            test: (value) => {
              let valid = true;
              if (!this.state.es_gratuito) {
                if (!(value.toString().trim().length >= 0)) {valid = false;}
              }
              return valid;
            },
            message: 'Campo obligatorio.',
          },
        ],
        errors: [],
        valid: true,
        state: '',
      },
      virtual_precio_cooporativo: {
        rules: [
          {
            test: (value) => {
              let valid = true;
              if (!this.state.es_gratuito) {
                if (!(value.toString().trim().length >= 0)) {valid = false;}
              }
              return valid;
            },
            message: 'Campo obligatorio.',
          },
        ],
        errors: [],
        valid: true,
        state: '',
      },
      hibrido_cantidad: {
        rules: [
          {
            test: (value) => {
              let valid = true;
              if (!this.state.es_gratuito) {
                if (!(value.toString().trim().length >= 0)) {valid = false;}
              }
              return valid;
            },
            message: 'Campo obligatorio.',
          },
        ],
        errors: [],
        valid: true,
        state: '',
      },
      hibrido_precio_habil_vitalicio: {
        rules: [
          {
            test: (value) => {
              let valid = true;
              if (!this.state.es_gratuito) {
                if (!(value.toString().trim().length >= 0)) {valid = false;}
              }
              return valid;
            },
            message: 'Campo obligatorio.',
          },
        ],
        errors: [],
        valid: true,
        state: '',
      },
      hibrido_precio_no_habil: {
        rules: [
          {
            test: (value) => {
              let valid = true;
              if (!this.state.es_gratuito) {
                if (!(value.toString().trim().length >= 0)) {valid = false;}
              }
              return valid;
            },
            message: 'Campo obligatorio.',
          },
        ],
        errors: [],
        valid: true,
        state: '',
      },
      hibrido_precio_publico: {
        rules: [
          {
            test: (value) => {
              let valid = true;
              if (!this.state.es_gratuito) {
                if (!(value.toString().trim().length >= 0)) {valid = false;}
              }
              return valid;
            },
            message: 'Campo obligatorio.',
          },
        ],
        errors: [],
        valid: true,
        state: '',
      },
      hibrido_precio_bachiller_estudiante: {
        rules: [
          {
            test: (value) => {
              let valid = true;
              if (!this.state.es_gratuito) {
                if (!(value.toString().trim().length >= 0)) {valid = false;}
              }
              return valid;
            },
            message: 'Campo obligatorio.',
          },
        ],
        errors: [],
        valid: true,
        state: '',
      },
      hibrido_precio_cooporativo: {
        rules: [
          {
            test: (value) => {
              let valid = true;
              if (!this.state.es_gratuito) {
                if (!(value.toString().trim().length >= 0)) {valid = false;}
              }
              return valid;
            },
            message: 'Campo obligatorio.',
          },
        ],
        errors: [],
        valid: true,
        state: '',
      },
      presencial_precio_no_habil: {
        rules: [
          {
            test: (value) => {
              let valid = true;
              if (!this.state.es_gratuito) {
                if (!(value.toString().trim().length >= 0)) {valid = false;}
              }
              return valid;
            },
            message: 'Campo obligatorio.',
          },
        ],
        errors: [],
        valid: true,
        state: '',
      },
    },
  };

  componentDidMount() {
    this.cargarProductos();
  }

  cargarProductos  = () => {
    this.setState({
      cargando_productos: true
    });
    CapacitacionService.getProductos('', (productos) => {
      if (productos) {
        this.setState({
          productos,
          cargando_productos: false
        });
      }
    }, (error) => {
      if (error) {
        message.error(error.message);
      }
      this.setState({
        cargando_productos: false
      });
    })
  }

  handleChangeName = (e, fieldName) => {
    this.setState({
      nombre: e.target.value,
    });

    this.uploadValidators(fieldName, e.target.value);
  };

  handleChangeEsBonificacion = (e) => {
    this.setState({
      es_uso_bonificacion: e.target.checked,
    });
  };

  handleChangeEsGratuito = (e) => {
    this.setState({
      es_gratuito: e.target.checked,
    }, () => {
      this.isFormValid();
    });
  };

  handleChangeFechaInicio = (date, fieldName) => {
    let fecha_inicio = '';
    if (date) {
      fecha_inicio = moment(date).format('DD/MM/YYYY');
    }
    this.setState({
      fecha_inicio: fecha_inicio,
    });
    this.uploadValidators(fieldName, fecha_inicio);
  };

  handleChangeFechaFin = (date, fieldName) => {
    let fecha_fin = '';
    if (date) {
      fecha_fin = moment(date).format('DD/MM/YYYY');
    }
    this.setState({
      fecha_fin: fecha_fin,
    });
    this.uploadValidators(fieldName, fecha_fin);
  };

  handleChangePresencialCantidad = (value, fieldName) => {
    this.setState({
      presencial_cantidad: value,
    });

    this.uploadValidators(fieldName, value);
  };

  handleChangePresencialPrecioHabilVitilicio  = (value, fieldName) => {
    this.setState({
      presencial_precio_habil_vitalicio: value,
    });

    this.uploadValidators(fieldName, value);
  };


  handleChangePresencialPrecioNoHabil  = (value, fieldName) => {
    this.setState({
      presencial_precio_no_habil: value,
    });

    this.uploadValidators(fieldName, value);
  };


  handleChangePresencialPrecioPublico  = (value, fieldName) => {
    this.setState({
      presencial_precio_publico: value,
    });

    this.uploadValidators(fieldName, value);
  };

  handleChangePresencialPrecioBachillerEstudiante  = (value, fieldName) => {
    this.setState({
      presencial_precio_bachiller_estudiante: value,
    });

    this.uploadValidators(fieldName, value);
  };

  handleChangePresencialPrecioCooperativo  = (value, fieldName) => {
    this.setState({
      presencial_precio_cooporativo: value,
    });

    this.uploadValidators(fieldName, value);
  };
  






  handleChangeVirtualCantidad = (value, fieldName) => {
    this.setState({
      virtual_cantidad: value,
    });

    this.uploadValidators(fieldName, value);
  };

  handleChangeVirtualPrecioHabilVitilicio  = (value, fieldName) => {
    this.setState({
      virtual_precio_habil_vitalicio: value,
    });

    this.uploadValidators(fieldName, value);
  };


  handleChangeVirtualPrecioNoHabil  = (value, fieldName) => {
    this.setState({
      virtual_precio_no_habil: value,
    });

    this.uploadValidators(fieldName, value);
  };


  handleChangeVirtualPrecioPublico  = (value, fieldName) => {
    this.setState({
      virtual_precio_publico: value,
    });

    this.uploadValidators(fieldName, value);
  };

  handleChangeVirtualPrecioBachillerEstudiante  = (value, fieldName) => {
    this.setState({
      virtual_precio_bachiller_estudiante: value,
    });

    this.uploadValidators(fieldName, value);
  };

  handleChangeVirtualPrecioCooperativo  = (value, fieldName) => {
    this.setState({
      virtual_precio_cooporativo: value,
    });

    this.uploadValidators(fieldName, value);
  };















  handleChangeHibridoCantidad = (value, fieldName) => {
    this.setState({
      hibrido_cantidad: value,
    });

    this.uploadValidators(fieldName, value);
  };

  handleChangeHibridoPrecioHabilVitilicio  = (value, fieldName) => {
    this.setState({
      hibrido_precio_habil_vitalicio: value,
    });

    this.uploadValidators(fieldName, value);
  };


  handleChangeHibridoPrecioNoHabil  = (value, fieldName) => {
    this.setState({
      hibrido_precio_no_habil: value,
    });

    this.uploadValidators(fieldName, value);
  };


  handleChangeHibridoPrecioPublico  = (value, fieldName) => {
    this.setState({
      hibrido_precio_publico: value,
    });

    this.uploadValidators(fieldName, value);
  };

  handleChangeHibridoPrecioBachillerEstudiante  = (value, fieldName) => {
    this.setState({
      hibrido_precio_bachiller_estudiante: value,
    });

    this.uploadValidators(fieldName, value);
  };

  handleChangeHibridoPrecioCooperativo  = (value, fieldName) => {
    this.setState({
      hibrido_precio_cooporativo: value,
    });

    this.uploadValidators(fieldName, value);
  };

  handleChangeProductoSku = (value, opt) => {
    const fieldName = 'producto_sku';
    this.setState(
      {
        producto_sku: opt.props.children,
        producto_formato: opt.producto.nombre,
        nombre: opt.producto.nombre,
      }, () => {
        this.uploadValidators(fieldName, opt.props.value);
      });
  };

  handleChangeDescuentoGlobal = (value) => {
    this.setState(
      {
        descuento_valor: value,
      });
  };

  handleChangeTipoDescuentoGlobal = (value, opt) => {
    this.setState(
      {
        descuento_tipo: value,
      });
  };

  handleSave = (data) => {
    const valid = this.isFormValid();
    if (valid) {
      this.props.onFormSubmit({
        id: this.state.id,
        nombre: this.state.nombre,
        producto_sku: this.state.producto_sku,
        producto_formato: this.state.producto_formato,
        fecha_inicio: this.state.fecha_inicio,
        fecha_fin: this.state.fecha_fin,
        es_uso_bonificacion: this.state.es_uso_bonificacion,
        es_gratuito: this.state.es_gratuito,
        presencial_cantidad: this.state.presencial_cantidad,
        presencial_precio_habil_vitalicio: this.state.presencial_precio_habil_vitalicio,
        presencial_precio_no_habil: this.state.presencial_precio_no_habil,
        presencial_precio_publico: this.state.presencial_precio_publico,
        presencial_precio_bachiller_estudiante: this.state.presencial_precio_bachiller_estudiante,
        presencial_precio_cooporativo: this.state.presencial_precio_cooporativo,
        virtual_cantidad: this.state.virtual_cantidad,
        virtual_precio_habil_vitalicio: this.state.virtual_precio_habil_vitalicio,
        virtual_precio_no_habil: this.state.virtual_precio_no_habil,
        virtual_precio_publico: this.state.virtual_precio_publico,
        virtual_precio_bachiller_estudiante: this.state.virtual_precio_bachiller_estudiante,
        virtual_precio_cooporativo: this.state.virtual_precio_cooporativo,
        hibrido_cantidad: this.state.hibrido_cantidad,
        hibrido_precio_habil_vitalicio: this.state.hibrido_precio_habil_vitalicio,
        hibrido_precio_no_habil: this.state.hibrido_precio_no_habil,
        hibrido_precio_publico: this.state.hibrido_precio_publico,
        hibrido_precio_bachiller_estudiante: this.state.hibrido_precio_bachiller_estudiante,
        hibrido_precio_cooporativo: this.state.hibrido_precio_cooporativo,
        descuento_valor: this.state.descuento_valor,
        descuento_tipo: this.state.descuento_tipo,
      });
      this.nameInput.focus();
    } else {
      message.destroy();
      message.error('No se puede guardar registro, verifique que no haya campos vacíos.');
    }
  };

  handleCancel = () => {
    this.props.onFormCancel();
  };

  uploadValidators(fieldName, value) {
    const validators = Helpers.validation.uploadValidators(fieldName, value, this.state.validators);
    this.setState({
      validators,
    });
  }

  actualizarListaErrores = (errors) => {
    Helpers.validation.actualizarListaErrores(errors, this.state.validators);
  };

  mostrarErroresValidacion = (fieldName) => {
    return Helpers.validation.mostrarErroresValidacion(fieldName, this.state.validators);
  };

  isFormValid = () => {
    const respuesta = Helpers.validation.isFormValid(this.state.validators, this.state);
    if (respuesta && respuesta.validators) {
      this.setState({
        validators: respuesta.validators,
      });
    }
    return respuesta.status;
  };

  render() {

    let productos = [];
    if (this.state.productos && this.state.productos.length > 0) {
      productos = this.state.productos.map((item) => {
        return (
          <Option key={item.id} value={item.id} producto={item}>
            {item.sku}
          </Option>
        );
      });
    }
    return (
      <Form>
        <Row>
          
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <FormItem
              {...formItemLayout}
              label="SKU Producto"
              validateStatus={this.state.validators.producto_sku.valid ? 'success' : 'error'}
              help={this.state.errors}
              required={true}
            >
              <Select
                showSearch
                optionFilterProp="children"
                value={this.state.producto_sku}
                onChange={this.handleChangeProductoSku}
                notFoundContent={this.props.cargando_productos ? <Spin size="small" /> : 'No se ha encontrado registros'}
              >
                {productos}
              </Select>
              {this.mostrarErroresValidacion('producto_sku')}
            </FormItem>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <FormItem
              {...formItemLayout}
              label="Nombre"
              validateStatus={this.state.validators.nombre.valid ? 'success' : 'error'}
              help={this.state.errors}
              required={true}
            >
              <Input
                onChange={(e) => this.handleChangeName(e, 'nombre')}
                value={this.state.nombre}
                autoComplete="off"
                id="nombre"
                ref={(input) => {
                  this.nameInput = input;
                }}
              />
              {this.mostrarErroresValidacion('nombre')}
            </FormItem>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <FormItem {...formItemLayout} validateStatus={this.state.validators.fecha_inicio.valid ? 'success' : 'error'} label="F. Inicio Formulario" help={this.state.errors} required={false}>
              <DatePicker
                value={
                  this.state.fecha_inicio && this.state.fecha_inicio !== 'Invalid date'
                    ? moment(this.state.fecha_inicio, dateFormat)
                    : null
                }
                format={dateFormat}
                id="fecha_inicio"
                placeholder="DD/MM/YYYY"
                onChange={(e) => this.handleChangeFechaInicio(e, 'fecha_inicio')}
              />
              {this.mostrarErroresValidacion('fecha_inicio')}
            </FormItem>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <FormItem {...formItemLayout} validateStatus={this.state.validators.fecha_fin.valid ? 'success' : 'error'} label="F. Fin Formulario" help={this.state.errors} required={false}>
              <DatePicker
                value={
                  this.state.fecha_fin && this.state.fecha_fin !== 'Invalid date'
                    ? moment(this.state.fecha_fin, dateFormat)
                    : null
                }
                format={dateFormat}
                id="fecha_fin"
                placeholder="DD/MM/YYYY"
                onChange={(e) => this.handleChangeFechaFin(e, 'fecha_fin')}
              />
              {this.mostrarErroresValidacion('fecha_fin')}
            </FormItem>
          </Col>
          <Col xs={24} sm={24} md={4} lg={4} xl={4}></Col>
          <Col xs={24} sm={24} md={8} lg={8} xl={8}>
          <Checkbox
              checked={this.state.es_gratuito}
              onChange={(e) => this.handleChangeEsGratuito(e)}
            >
              Capacitación gratuito
            </Checkbox>
          </Col>
          <Col xs={24} sm={24} md={4} lg={4} xl={4}></Col>
          <Col xs={24} sm={24} md={8} lg={8} xl={8}>
          <Checkbox
              checked={this.state.es_uso_bonificacion}
              onChange={(e) => this.handleChangeEsBonificacion(e)}
            >
              USO DE BONIFICACIÒN
            </Checkbox>
          </Col>
        </Row>
        <br/>
        <Row>
          <Col xs={24} sm={24} md={8} lg={8} xl={8}>
            <b>PRESENCIAL</b>
            <FormItem
              {...formItemLayoutMedio}
              label="Cant. Personas"
              validateStatus={this.state.validators.presencial_cantidad.valid ? 'success' : 'error'}
              help={this.state.errors}
              required={!this.state.es_gratuito}
            >
              <InputNumber
                onChange={(e) => this.handleChangePresencialCantidad(e, 'presencial_cantidad')}
                value={this.state.presencial_cantidad}
                autoComplete="off"
                min={0}
                id="presencial_cantidad"
              />
              {this.mostrarErroresValidacion('presencial_cantidad')}
            </FormItem>
            <b>Estado Colegiado &nbsp;&nbsp;&nbsp;Precio</b>
            <br/>
            <br/>
            <FormItem
              {...formItemLayoutMedio}
              label="Hábil Vitalicio"
              validateStatus={this.state.validators.presencial_precio_habil_vitalicio.valid ? 'success' : 'error'}
              help={this.state.errors}
              required={!this.state.es_gratuito}
            >
              <InputNumber
                onChange={(e) => this.handleChangePresencialPrecioHabilVitilicio(e, 'presencial_precio_habil_vitalicio')}
                value={this.state.presencial_precio_habil_vitalicio}
                autoComplete="off"
                min={0}
                id="presencial_precio_habil_vitalicio"
              />
              {this.mostrarErroresValidacion('presencial_precio_habil_vitalicio')}
            </FormItem>
            <FormItem
              {...formItemLayoutMedio}
              label="No hábil"
              validateStatus={this.state.validators.presencial_precio_no_habil.valid ? 'success' : 'error'}
              help={this.state.errors}
              required={!this.state.es_gratuito}
            >
              <InputNumber
                onChange={(e) => this.handleChangePresencialPrecioNoHabil(e, 'presencial_precio_no_habil')}
                value={this.state.presencial_precio_no_habil}
                autoComplete="off"
                min={0}
                id="presencial_precio_no_habil"
              />
              {this.mostrarErroresValidacion('presencial_precio_no_habil')}
            </FormItem>
            <FormItem
              {...formItemLayoutMedio}
              label="Público General"
              validateStatus={this.state.validators.presencial_precio_publico.valid ? 'success' : 'error'}
              help={this.state.errors}
              required={!this.state.es_gratuito}
            >
              <InputNumber
                onChange={(e) => this.handleChangePresencialPrecioPublico(e, 'presencial_precio_publico')}
                value={this.state.presencial_precio_publico}
                autoComplete="off"
                min={0}
                id="presencial_precio_publico"
              />
              {this.mostrarErroresValidacion('presencial_precio_publico')}
            </FormItem>
            <FormItem
              {...formItemLayoutMedio}
              label="Bachiller/Estudiante"
              validateStatus={this.state.validators.presencial_precio_bachiller_estudiante.valid ? 'success' : 'error'}
              help={this.state.errors}
              required={!this.state.es_gratuito}
            >
              <InputNumber
                onChange={(e) => this.handleChangePresencialPrecioBachillerEstudiante(e, 'presencial_precio_bachiller_estudiante')}
                value={this.state.presencial_precio_bachiller_estudiante}
                autoComplete="off"
                min={0}
                id="presencial_precio_bachiller_estudiante"
              />
              {this.mostrarErroresValidacion('presencial_precio_bachiller_estudiante')}
            </FormItem>
            <FormItem
              {...formItemLayoutMedio}
              label="Corporativo"
              validateStatus={this.state.validators.presencial_precio_cooporativo.valid ? 'success' : 'error'}
              help={this.state.errors}
              required={!this.state.es_gratuito}
            >
              <InputNumber
                onChange={(e) => this.handleChangePresencialPrecioCooperativo(e, 'presencial_precio_cooporativo')}
                value={this.state.presencial_precio_cooporativo}
                autoComplete="off"
                min={0}
                id="presencial_precio_cooporativo"
              />
              {this.mostrarErroresValidacion('presencial_precio_cooporativo')}
            </FormItem>
          </Col>
          <Col xs={24} sm={24} md={8} lg={8} xl={8}>
            <b>VIRTUAL</b>
            <FormItem
              {...formItemLayoutMedio}
              label="Cant. Personas"
              validateStatus={this.state.validators.virtual_cantidad.valid ? 'success' : 'error'}
              help={this.state.errors}
              required={!this.state.es_gratuito}
            >
              <InputNumber
                onChange={(e) => this.handleChangeVirtualCantidad(e, 'virtual_cantidad')}
                value={this.state.virtual_cantidad}
                autoComplete="off"
                min={0}
                id="virtual_cantidad"
              />
              {this.mostrarErroresValidacion('virtual_cantidad')}
            </FormItem>
            <b>Estado Colegiado &nbsp;&nbsp;&nbsp;Precio</b>
            <br/>
            <br/>
            <FormItem
              {...formItemLayoutMedio}
              label="Hábil Vitalicio"
              validateStatus={this.state.validators.virtual_precio_habil_vitalicio.valid ? 'success' : 'error'}
              help={this.state.errors}
              required={!this.state.es_gratuito}
            >
              <InputNumber
                onChange={(e) => this.handleChangeVirtualPrecioHabilVitilicio(e, 'virtual_precio_habil_vitalicio')}
                value={this.state.virtual_precio_habil_vitalicio}
                autoComplete="off"
                min={0}
                id="virtual_precio_habil_vitalicio"
              />
              {this.mostrarErroresValidacion('virtual_precio_habil_vitalicio')}
            </FormItem>
            <FormItem
              {...formItemLayoutMedio}
              label="No hábil"
              validateStatus={this.state.validators.virtual_precio_no_habil.valid ? 'success' : 'error'}
              help={this.state.errors}
              required={!this.state.es_gratuito}
            >
              <InputNumber
                onChange={(e) => this.handleChangeVirtualPrecioNoHabil(e, 'virtual_precio_no_habil')}
                value={this.state.virtual_precio_no_habil}
                autoComplete="off"
                min={0}
                id="virtual_precio_no_habil"
              />
              {this.mostrarErroresValidacion('virtual_precio_no_habil')}
            </FormItem>
            <FormItem
              {...formItemLayoutMedio}
              label="Público General"
              validateStatus={this.state.validators.virtual_precio_publico.valid ? 'success' : 'error'}
              help={this.state.errors}
              required={!this.state.es_gratuito}
            >
              <InputNumber
                onChange={(e) => this.handleChangeVirtualPrecioPublico(e, 'virtual_precio_publico')}
                value={this.state.virtual_precio_publico}
                autoComplete="off"
                min={0}
                id="virtual_precio_publico"
              />
              {this.mostrarErroresValidacion('virtual_precio_publico')}
            </FormItem>
            <FormItem
              {...formItemLayoutMedio}
              label="Bachiller/Estudiante"
              validateStatus={this.state.validators.virtual_precio_bachiller_estudiante.valid ? 'success' : 'error'}
              help={this.state.errors}
              required={!this.state.es_gratuito}
            >
              <InputNumber
                onChange={(e) => this.handleChangeVirtualPrecioBachillerEstudiante(e, 'virtual_precio_bachiller_estudiante')}
                value={this.state.virtual_precio_bachiller_estudiante}
                autoComplete="off"
                min={0}
                id="virtual_precio_bachiller_estudiante"
              />
              {this.mostrarErroresValidacion('virtual_precio_bachiller_estudiante')}
            </FormItem>
            <FormItem
              {...formItemLayoutMedio}
              label="Corporativo"
              validateStatus={this.state.validators.virtual_precio_cooporativo.valid ? 'success' : 'error'}
              help={this.state.errors}
              required={!this.state.es_gratuito}
            >
              <InputNumber
                onChange={(e) => this.handleChangeVirtualPrecioCooperativo(e, 'virtual_precio_cooporativo')}
                value={this.state.virtual_precio_cooporativo}
                autoComplete="off"
                min={0}
                id="virtual_precio_cooporativo"
              />
              {this.mostrarErroresValidacion('virtual_precio_cooporativo')}
            </FormItem>
          </Col>
          <Col xs={24} sm={24} md={8} lg={8} xl={8}>
            <b>HIBRIDO</b>
            <FormItem
              {...formItemLayoutMedio}
              label="Cant. Personas"
              validateStatus={this.state.validators.hibrido_cantidad.valid ? 'success' : 'error'}
              help={this.state.errors}
              required={!this.state.es_gratuito}
            >
              <InputNumber
                onChange={(e) => this.handleChangeHibridoCantidad(e, 'hibrido_cantidad')}
                value={this.state.hibrido_cantidad}
                autoComplete="off"
                min={0}
                id="hibrido_cantidad"
              />
              {this.mostrarErroresValidacion('hibrido_cantidad')}
            </FormItem>
            <b>Estado Colegiado &nbsp;&nbsp;&nbsp;Precio</b>
            <br/>
            <br/>
            <FormItem
              {...formItemLayoutMedio}
              label="Hábil Vitalicio"
              validateStatus={this.state.validators.hibrido_precio_habil_vitalicio.valid ? 'success' : 'error'}
              help={this.state.errors}
              required={!this.state.es_gratuito}
            >
              <InputNumber
                onChange={(e) => this.handleChangeHibridoPrecioHabilVitilicio(e, 'hibrido_precio_habil_vitalicio')}
                value={this.state.hibrido_precio_habil_vitalicio}
                autoComplete="off"
                min={0}
                id="hibrido_precio_habil_vitalicio"
              />
              {this.mostrarErroresValidacion('hibrido_precio_habil_vitalicio')}
            </FormItem>
            <FormItem
              {...formItemLayoutMedio}
              label="No hábil"
              validateStatus={this.state.validators.hibrido_precio_no_habil.valid ? 'success' : 'error'}
              help={this.state.errors}
              required={!this.state.es_gratuito}
            >
              <InputNumber
                onChange={(e) => this.handleChangeHibridoPrecioNoHabil(e, 'hibrido_precio_no_habil')}
                value={this.state.hibrido_precio_no_habil}
                autoComplete="off"
                min={0}
                id="hibrido_precio_no_habil"
              />
              {this.mostrarErroresValidacion('hibrido_precio_no_habil')}
            </FormItem>
            <FormItem
              {...formItemLayoutMedio}
              label="Público General"
              validateStatus={this.state.validators.hibrido_precio_publico.valid ? 'success' : 'error'}
              help={this.state.errors}
              required={!this.state.es_gratuito}
            >
              <InputNumber
                onChange={(e) => this.handleChangeHibridoPrecioPublico(e, 'hibrido_precio_publico')}
                value={this.state.hibrido_precio_publico}
                autoComplete="off"
                min={0}
                id="hibrido_precio_publico"
              />
              {this.mostrarErroresValidacion('hibrido_precio_publico')}
            </FormItem>
            <FormItem
              {...formItemLayoutMedio}
              label="Bachiller/Estudiante"
              validateStatus={this.state.validators.hibrido_precio_bachiller_estudiante.valid ? 'success' : 'error'}
              help={this.state.errors}
              required={!this.state.es_gratuito}
            >
              <InputNumber
                onChange={(e) => this.handleChangeHibridoPrecioBachillerEstudiante(e, 'hibrido_precio_bachiller_estudiante')}
                value={this.state.hibrido_precio_bachiller_estudiante}
                autoComplete="off"
                min={0}
                id="hibrido_precio_bachiller_estudiante"
              />
              {this.mostrarErroresValidacion('hibrido_precio_bachiller_estudiante')}
            </FormItem>
            <FormItem
              {...formItemLayoutMedio}
              label="Corporativo"
              validateStatus={this.state.validators.hibrido_precio_cooporativo.valid ? 'success' : 'error'}
              help={this.state.errors}
              required={!this.state.es_gratuito}
            >
              <InputNumber
                onChange={(e) => this.handleChangeHibridoPrecioCooperativo(e, 'hibrido_precio_cooporativo')}
                value={this.state.hibrido_precio_cooporativo}
                autoComplete="off"
                min={0}
                id="hibrido_precio_cooporativo"
              />
              {this.mostrarErroresValidacion('hibrido_precio_cooporativo')}
            </FormItem>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <FormItem
              {...formItemLayoutMedio}
              label="Desc. Corporativo"
              help={this.state.errors}
              required={false}
            >
              <InputNumber
                addonAfter={
                  <Select style={{ width: 80 }} value={this.state.descuento_tipo} onChange={this.handleChangeTipoDescuentoGlobal}>
                    <Option value=""></Option>
                    <Option value="%">%</Option>
                    <Option
                      value="V.V."
                    >
                      V.V.
                    </Option>
                    <Option
                      value="P.V."
                    >
                      P.V.
                    </Option>
                  </Select>
                }
                onChange={this.handleChangeDescuentoGlobal}
                value={this.state.descuento_valor}
                min={0}
              />
            </FormItem>
          </Col>
        </Row>
        
        
        
        
        <FormItem {...formItemLayoutWithOutLabel} label="">
          <Button type="primary" onClick={this.handleSave} htmlType="submit" loading={this.props.guardando}>
            Guardar
          </Button>
          <Button style={{ marginLeft: 8 }} onClick={this.handleCancel}>
            Cancelar
          </Button>
        </FormItem>
      </Form>
    );
  }
}

export default CapacitacionFormulario;
